import { ValidatorFn, AbstractControl } from '@angular/forms';
/**
 * @return {?}
 */
export function NoLeadingZeroValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (control.value.substring(0, 1) === '0') {
      return { leadingzeronotallowed: { value: control.value } };
    }

    return null;
  };
}
